import { render, staticRenderFns } from "./MyAssess.vue?vue&type=template&id=075dd5f1&scoped=true"
import script from "./MyAssess.vue?vue&type=script&lang=js"
export * from "./MyAssess.vue?vue&type=script&lang=js"
import style0 from "./MyAssess.vue?vue&type=style&index=0&id=075dd5f1&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "075dd5f1",
  null
  
)

export default component.exports